export default __webpack_public_path__ + "static/media/Quiken_Ecommerce.36485478.png";